// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7bb40482","496":"33bff9ef","545":"5a21970e"}[chunkId] + ".chunk.js";
};